import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { applicationPreviewTranslations } from "@krea/customer-features/shared-components/application-questions-preview/translations";
import { bidsTranslations } from "@krea/customer-features/shared-components/bid-dashboards/translations";
import { getPrimaryLanguage } from "@krea/customer-features/utils";
import { formFieldsTranslations } from "@krea/shared/design-system/fields/translations";
import { agentsTranslations } from "@krea/shared/features/agents/translations";
import { loanWidgetTranslations } from "@krea/shared/features/loan-widget/translations";
import { bankIDTranslations } from "@krea/shared/features/bankID/translations";

// Disable localStorage usage for language detection and rely on cookies instead
// localStorage is not available in some browsers some times and causes crashes.
const languageDetector = new LanguageDetector(null, {
  caches: ["cookie"],
});

const namespaces = [
  "customerWeb",
  bankIDTranslations.namespace,
  bidsTranslations.namespace,
  agentsTranslations.namespace,
  applicationPreviewTranslations.namespace,
  formFieldsTranslations.namespace,
  loanWidgetTranslations.namespace,
  "common",
];
i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        customerWeb: require("./translations/customer/en.json"),
        common: require("@krea/customer-features/translations/common/en.json"),
        [bankIDTranslations.namespace]: bankIDTranslations.en,
        [bidsTranslations.namespace]: bidsTranslations.en,
        [agentsTranslations.namespace]: agentsTranslations.en,
        [applicationPreviewTranslations.namespace]:
          applicationPreviewTranslations.en,
        [formFieldsTranslations.namespace]: formFieldsTranslations.en,
        [loanWidgetTranslations.namespace]: loanWidgetTranslations.en,
      },
      sv: {
        customerWeb: require("./translations/customer/sv.json"),
        common: require("@krea/customer-features/translations/common/sv.json"),
        [bankIDTranslations.namespace]: bankIDTranslations.sv,
        [bidsTranslations.namespace]: bidsTranslations.sv,
        [agentsTranslations.namespace]: agentsTranslations.sv,
        [applicationPreviewTranslations.namespace]:
          applicationPreviewTranslations.sv,
        [formFieldsTranslations.namespace]: formFieldsTranslations.sv,
        [loanWidgetTranslations.namespace]: loanWidgetTranslations.sv,
      },
      fi: {
        customerWeb: require("./translations/customer/fi.json"),
        common: require("@krea/customer-features/translations/common/fi.json"),
        [bankIDTranslations.namespace]: bankIDTranslations.fi,
        [bidsTranslations.namespace]: bidsTranslations.fi,
        [agentsTranslations.namespace]: agentsTranslations.fi,
        [applicationPreviewTranslations.namespace]:
          applicationPreviewTranslations.fi,
        [formFieldsTranslations.namespace]: formFieldsTranslations.fi,
        [loanWidgetTranslations.namespace]: loanWidgetTranslations.fi,
      },
    },
    lng: getPrimaryLanguage(),
    fallbackLng: "en",
    supportedLngs: ["sv", "en", "fi"],
    ns: namespaces,
    defaultNS: namespaces,
    fallbackNS: namespaces,
    interpolation: {
      escapeValue: false,
    },
    react: {
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p", "ul", "li", "a"],
    },
  });

// eslint-disable-next-line import/no-default-export
export default i18n;
